import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PROJECT_STATE_TAG_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, PROJECT_STATE_TAG_TRANSLATION_KEY, {
  PARTICIPATION_PROJECT: 'Projeto de participação',
  FREE_COURSE: 'Curso livre',
  DRAFT: 'Esboço',
  PUBLISHED: 'Em revisão',
  OBSERVED: 'Com observações',
  CERTIFIED: 'Certificado',
  APPROVED: 'Aprovado',
  FINISHED: 'Concluído',
  EXPIRED: 'Fora de tempo',
  TEACHER_PROJECT: 'Projeto do professor'
});